import type { KidStore } from './interfaces'

export const createInitialState = (): KidStore => ({
  activeKidId: null,
  _hydrated: false,
  disciplinesByKid: {},
})
